var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#151521"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.5377C8 23.2551 8.13963 23.9653 8.41092 24.6281C8.68221 25.2908 9.07985 25.8929 9.58112 26.4001C10.5935 27.4245 11.9666 28 13.3983 28H27.7938C28.8566 28.0019 29.8806 27.596 30.6592 26.864C31.4378 26.132 31.9131 25.1284 31.9892 24.0558C32.0653 22.9831 31.7366 21.9212 31.0693 21.0842C30.402 20.2471 29.4458 19.6973 28.3936 19.5456C28.4053 17.4806 27.6734 15.482 26.3346 13.9233C24.9959 12.3646 23.142 11.3525 21.1194 11.0764C19.0969 10.8002 17.0442 11.2787 15.345 12.4226C13.6458 13.5664 12.4165 15.2973 11.8868 17.2915C10.7653 17.6229 9.78022 18.3134 9.07942 19.2593C8.37862 20.2052 7.99987 21.3555 8 22.5377Z",
    stroke: "#151521",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.499e7a0d9cf25e143c6dc5414ce481cb.svg";
export { ForwardRef as ReactComponent };